import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, BeenhereRounded } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 120 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function Concept(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [concepts, setConcepts] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function listConcepts() {
    setDataLoading(true);
    let response = await wsGetAll('pymt/concept');
    setDataLoading(false);
    if (response.success) setConcepts(response.data);
  }

  useEffect(() => {
    listConcepts();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={listConcepts} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.PYMT_CONCEPTS_STORE}
              component={
                <CardIcon color={props.themeContext.buttonColor}>
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de conceptos {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Conceptos"
              defaultWidth={1000}
              columns={columns}
              data={concepts.map((item, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.PYMT_CONCEPTS_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.PYMT_CONCEPTS_DELETED}>
                        <ButtonDelete entity="pymt/concept" id={item.id} reload={listConcepts} />
                      </AllowedGuard>
                    </div>
                  ),
                  description: item.description,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
